import { type ReactNode } from 'react';
import { useHydrateAtoms } from 'jotai/utils';

import { type LandingVariant, landingVariantAtom } from '../../atoms/landing-variant';

type Props = {
    landingVariant: LandingVariant;
    children?: ReactNode;
};

/**
 * Заполняет landingVariantAtom — используется и при SSR, и при гидрации на клиенте.
 */
export const HydrateLandingVariant = ({ landingVariant, children }: Props) => {
    useHydrateAtoms([[landingVariantAtom, landingVariant]]);

    return children;
};
